import { chakra, Box } from '@chakra-ui/react';

export const AppContainer = chakra(Box, {
  baseStyle: () => ({
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  }),
});
